"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessoriesCartCms = void 0;
var AccessoriesCartCms = /** @class */ (function () {
    function AccessoriesCartCms() {
        this.lineOfBusinessName = 'Accessories';
        this.editCTALabel = 'Edit';
        this.estimatedSalesTax = 'Estimated sales tax';
        this.taxNotCalculatedSubText = '(Calculated at checkout)';
        this.taxTooltipUpBsse = "Estimated sales tax on your accessories is based on your shopping ZIP Code.\n    Actual sales tax may vary and is based on the shipping ZIP Code you provide at checkout.";
        this.taxTooltipUpWireless = "Estimated sales tax on your accessories is based on your shopping ZIP Code.\n    Actual sales tax may vary and is based on your shipping ZIP Code or the ZIP Code of the AT&T store where your items will be picked up (if available).";
        this.taxTooltipUp = "Estimated sales tax on your accessories is based on your shopping ZIP Code.\n   Actual sales tax may vary and is based on the shipping ZIP Code you provide at checkout.";
        this.taxTooltipDown = "Sales taxes will be calculated after you submit your order.\n    We'll include them on your confirmation email.";
        this.dueTodayLegalIDP = {
            legalModalPath: [
                '/idpassets/fragment/legal/2007b/legalmodal/offers/wireline/cart/duetodaychargesdtvlm.cmsfeed.js',
            ],
            legalShortPath: {
                legalText: 'Due today',
                shortLegalLinkLabel: 'See details',
            },
        };
        this.dueTodayAccLegalIDP = {
            legalModalPath: [
                '/idpassets/fragment/legal/2108a/legalmodal/offers/wireline/cart/duetodayacclm.cmsfeed.js',
            ],
            legalShortPath: {
                legalText: 'Due today',
                shortLegalLinkLabel: 'See details',
            },
        };
        this.quantity = 'Qty:';
        this.retailPriceLabel = 'Retail price ($ {0}/ea.  |  Qty. {1})';
        this.removeItemsLinkLabel = 'Remove accessories';
        this.dueOneTimeCharges = 'One-time charges TEST';
        this.dueMonthlyHeading = 'Monthly charges';
        this.dueOnFirstBillLegal = '';
        this.emptyCartModal = {
            cancelButtonLabel: 'No',
            removeButtonLabel: 'Yes',
            removeMessageBodyLabel: "We'll also remove your accesorries. To qualify for special promotions,\n      your bundle must include TV.",
            removeMessageHeaderLabel: "Heads up:",
            removeModalBody: 'Sure you want to remove this?',
            removeModalTitle: 'Remove from cart',
        };
    }
    return AccessoriesCartCms;
}());
exports.AccessoriesCartCms = AccessoriesCartCms;
//# sourceMappingURL=AccessoriesCart.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/AccessoriesCart/AccessoriesCart.cms.js
// module id = 1432
// module chunks = 8